/*  */
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'str' implicitly has an 'any' type.
function leftpad(str, padding, length) {
  const padded = padding.repeat(length) + str;

  return padded.slice(padded.length - length);
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'seconds' implicitly has an 'any' type.
export default function formatMediaTime(seconds, showHours) {
  let time = '';

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  const hours = parseInt(seconds / 3600, 10);
  if (showHours && hours) {
    time += leftpad(hours.toString(), '0', 2) + ':';
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  const minutes = parseInt((seconds % 3600) / 60, 10);
  time += leftpad(minutes.toString(), '0', 2) + ':';

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  const secondsInt = parseInt(seconds % 60, 10);
  time += leftpad(secondsInt.toString(), '0', 2);

  return time;
}
